module.exports = __webpack_public_path__ + "img/emptyfdbck.1977f356.svg";